//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import options from "@/common/options.json";
export default {
    data() {
        return {
            routerLink: options.routerLink,
            isClick: false
        };
    },
    methods: {
        onJump(path) {
            window.location.href = path
        }
    }    
};



// WEBPACK FOOTER //
// ./src/components/foot.vue